import type { ProjectsRepository } from '../domain/repositories/ProjectsRepository.interface';
import { Project } from '../domain/entities/Project.entity';
import { projectsContent } from '../content/projects.content';

export class StaticProjectsSource implements ProjectsRepository {
  public async getAll(): Promise<Project[]> {
    return projectsContent.map((input) => Project.create(input));
  }

  public async getBySlug(slug: string): Promise<Project | null> {
    const match = projectsContent.find((input) => input.slug === slug);
    return match ? Project.create(match) : null;
  }
}
